// removed by extract-text-webpack-plugin
module.exports = {"circleButton":"NRg9g","iconBase":"_18JlV"};